const translations = {
  en: {
    title: 'How to fill files used to update tables',
    summary:
      'Quick guide to prepare update files without breaking columns, '
      + 'formats, or the import flow.',
    category: 'Database management',
    tags: ['Upload', 'Spreadsheet', 'Import'] as string[],
    hero:
      'Use this content as a reference before uploading a file. '
      + 'The goal is to keep the table layout intact and avoid '
      + 'errors during background processing.',
    beforeUploadTitle: 'Before uploading the file',
    beforeUploadItem1:
      'Download a recent export from the same table whenever '
      + 'possible. It is the safest template for structure '
      + 'and column order.',
    beforeUploadItem2:
      'Edit only the data that needs to change. Do not remove '
      + 'headers, rename columns, or reorder the layout '
      + 'unless the import process explicitly allows it.',
    beforeUploadItem3:
      'Save the final file using the separator expected by the '
      + 'process. Changes in delimiter, encoding, or file '
      + 'format may lead to silent failures or incorrect '
      + 'processing.',
    structureTitle: 'Structure and formatting care',
    structureItem1:
      'Keep mandatory columns even when some values are empty. '
      + 'Missing columns are usually more critical than empty '
      + 'cells.',
    structureItem2:
      'Avoid formulas, extra tabs, merged cells, and '
      + 'spreadsheet auto-formatting. The final file should '
      + 'contain clean and predictable data only.',
    structureItem3:
      'Review dates, decimal numbers, and codes before '
      + 'upload. If the source uses different conventions, '
      + 'normalize the content first.',
    flowTitle: 'Recommended flow',
    flowStep1: '1. Download the latest available export for the target table.',
    flowStep2: '2. Fill or adjust the file without changing the base structure.',
    flowStep3: '3. Upload the file and monitor the update status from the tables list itself.',
    flowStep4:
      '4. If an error occurs, open the error details to '
      + 'identify the row or rule that needs correction, then '
      + 'upload a new version.',
    warningLabel: 'Warning',
    warningText:
      'Very old files, files exported from another table, or '
      + 'files manually changed without preserving headers and '
      + 'data types often trigger validation errors or '
      + 'inconsistent updates.',
    mediaTitle: 'Rich media ready area',
    mediaDescription:
      'The same content supports video, images, links, and '
      + 'custom blocks. For new guides, you only need to add '
      + 'the article folder inside the Help Center page.',
  },
  pt: {
    title: 'Como preencher arquivos para atualização das tabelas',
    summary:
      'Guia rápido para preparar arquivos de atualização sem '
      + 'quebrar colunas, formatos e fluxo de importação.',
    category: 'Gerenciamento de banco de dados',
    tags: ['Upload', 'Planilha', 'Importação'] as string[],
    hero:
      'Use este conteúdo como referência antes de subir um '
      + 'arquivo. A ideia é manter o layout da tabela intacto '
      + 'e evitar erros de processamento em background.',
    beforeUploadTitle: 'Antes de enviar o arquivo',
    beforeUploadItem1:
      'Baixe uma exportação recente da mesma tabela sempre '
      + 'que possível. Ela serve como modelo mais seguro '
      + 'para estrutura e ordem de colunas.',
    beforeUploadItem2:
      'Edite apenas os dados necessários. Não remova '
      + 'cabeçalhos, não renomeie colunas e não troque a '
      + 'ordem do layout sem confirmar se a importação '
      + 'aceita isso.',
    beforeUploadItem3:
      'Salve o arquivo final usando o mesmo separador '
      + 'esperado pelo processo. Mudanças em delimitador, '
      + 'codificação ou formato podem gerar falha silenciosa '
      + 'ou processamento incorreto.',
    structureTitle: 'Cuidados com estrutura e formatação',
    structureItem1:
      'Mantenha as colunas obrigatórias mesmo quando alguns '
      + 'valores estiverem vazios. A ausência de colunas '
      + 'costuma ser mais crítica do que células vazias.',
    structureItem2:
      'Evite fórmulas, abas extras, mesclagens e formatações '
      + 'automáticas de planilha. O ideal é que o arquivo '
      + 'final contenha apenas dados limpos e previsíveis.',
    structureItem3:
      'Revise datas, números decimais e códigos antes do '
      + 'upload. Se a origem usa convenções diferentes, '
      + 'normalize o conteúdo antes de importar.',
    flowTitle: 'Fluxo recomendado',
    flowStep1: '1. Baixe a última exportação disponível da tabela desejada.',
    flowStep2: '2. Preencha ou ajuste os dados no arquivo sem alterar a estrutura base.',
    flowStep3: '3. Faça o upload e acompanhe o status da atualização na própria página.',
    flowStep4:
      '4. Se houver erro, abra o detalhe do erro para '
      + 'identificar a linha ou regra que precisa ser '
      + 'corrigida e envie uma nova versão do arquivo.',
    warningLabel: 'Atenção',
    warningText:
      'Arquivos muito antigos, exportados de outra tabela ou '
      + 'ajustados manualmente sem preservar cabeçalho e tipo '
      + 'de dado tendem a causar erros de validação ou '
      + 'atualização inconsistente.',
    mediaTitle: 'Área pronta para mídia rica',
    mediaDescription:
      'Esse mesmo conteúdo aceita vídeo, imagens, links e '
      + 'blocos personalizados. Para novos guias, basta '
      + 'adicionar a pasta do artigo dentro da página da '
      + 'Central de Ajuda.',
  },
};

export default translations;
